
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambassadors/[id]",
      function () {
        return require("private-next-pages/ambassadors/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambassadors/[id]"])
      });
    }
  